import { type GetServerSideProps } from 'next'

import { createServerSideProps } from '@core/lib/data-fetching'
import { getCatalog } from '@services/catalog'
import { LoginReset } from '@components/Login/LoginReset'

const LoginResetPage = () => {
  return <LoginReset />
}

export default LoginResetPage

export const getServerSideProps: GetServerSideProps = createServerSideProps(async ({ props }) => {
  const documentTypesCatalog = await getCatalog('documentTypes')

  return {
    props: {
      ...props,
      catalog: {
        documentTypesCatalog: documentTypesCatalog ?? []
      }
    }
  }
})
